import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { authUniversalLogin } from '@app/redux/auth/actions';

const useInitiateUserLogin = () => {
  const dispatch = useDispatch();
  return useCallback(
    (
      defaultTab = 'signup',
      state = {},
      connection: string | undefined = undefined,
    ) => dispatch(authUniversalLogin(defaultTab, state, connection)),
    [dispatch],
  );
};

export default useInitiateUserLogin;
